import dayjs from "dayjs";

export function extractSelectablesProperties(obj: any, mappings: Record<string, string>): any {
  const result = JSON.parse(JSON.stringify(obj)); // Crear una copia profunda del objeto

  Object.entries(mappings).forEach(([sourcePath, targetPath]) => {
    const sourceKeys = sourcePath.split('.'); // Ruta original
    const targetKeys = targetPath.split('.'); // Nueva ruta

    // Obtener el valor de la ruta original
    let value = obj;
    for (const key of sourceKeys) {
      value = value?.[key];
      if (value === undefined) break;
    }

    // Establecer el valor en la nueva ruta
    if (value !== undefined) {
      let current = result;
      for (let i = 0; i < targetKeys.length - 1; i++) {
        const key = targetKeys[i];
        current[key] = current[key] || {};
        current = current[key];
      }
      current[targetKeys[targetKeys.length - 1]] = value;
    }
  });

  return result;
}

function normalizeString(input: string): string {
  return input.replace(/[^a-zA-Z0-9]/g, '-').replace(/-+/g, '-');
}

export function formatNumber(num: number, totalLength: number = 8): string {
  return num.toString().padStart(totalLength, '0');
}

export function stringToPath(str: string): string {
  return str.replace(/_([a-z])/g, (match, p1) => '.' + p1);
}


export function isKeyContained(shortKey: string, longKey: string): boolean {
  return longKey.startsWith(shortKey + ".");
}

//FIXME in shared-utils?
export function formatFilters (filters: any) {
  return Object.keys(filters || {}).reduce((acc: any, key) => {
    let value = (filters as { [k: string]: any })[key];
    if (key.includes('date_') && typeof value === 'string') {
      //FIXME sbagliato
      value = dayjs(value).toDate();// era new Date(value);... da controllare
    }
    acc[key.replace('f.', '')] = value;
    return acc;
  }, {});
}

export function toFilters (filters: any) {
  return Object.keys(filters || {}).reduce((acc: any, key) => {
    let value = (filters as { [k: string]: any })[key];
    if (key.includes('date_') && typeof value === 'string') {
      //FIXME sbagliato
      value = dayjs(value).toDate();// era new Date(value);... da controllare
    }
    acc['f.'+key] = value;
    return acc;
  }, {});
}


export function validateInput(event: KeyboardEvent) {
  const regex = /^[a-zA-Z0-9]$/;
  if (!regex.test(event.key)) {
    event.preventDefault();
  }
}

export function isDefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function isNotDefined<T>(value: T | null | undefined){
  return !isDefined(value);
}

export function compareEntity(a: any, b: any) {
  if ( isNotDefined(a) && isNotDefined(b) ) {
    return true;
  }

  if ((isNotDefined(a) && isDefined(b)) || (isNotDefined(b) && isDefined(a))) {
    return false;
  }

  const matchFields= ['id', 'code', 'value'];

  for (const field of matchFields) {
    if( isDefined(a[field]) && isDefined(b[field]) && a[field] == b[field]){
      return true;
    }
  }

  return  a === b;
}

